import React, { useState } from 'react';
import 'twin.macro';
import { Button } from '../button';
import { Input } from './FormParticals';
import { Icon } from '../icon';
import { LoaderIcon } from 'icons';
import { submitItemReport } from 'services/dumpert';
import { Notification } from '../notifications';
import { useUnmounted } from '../common/hooks';

export const SUBMIT_SUCCESS = 'Je tip is verzonden, bedankt!';

export const SUBMIT_ERROR = 'Er gaat iets fout... probeer het nog eens';

const reportArticleOptions = [
  { label: 'REPOST!', value: 'repost' },
  { label: 'Dit item is NSFW', value: 'nsfw' },
  { label: 'Dit item schendt mijn privacy', value: 'privacy' },
  { label: 'Anders...', value: 'anders' },
];

export const ReportForm = ({ itemId, setReportFormActive }) => {
  const [radioValue, setRadioValue] = useState('repost');
  const [extraInput, setExtraInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ state: '' });
  const unmounted = useUnmounted();

  const submit = (e) => {
    e.preventDefault();
    setLoading(true);
    setNotification({});

    return submitItemReport(itemId, {
      reason: radioValue,
      extra: extraInput,
    })
      .then(() => {
        if (!unmounted.current) {
          setExtraInput('');
          setNotification({ state: 'success', message: SUBMIT_SUCCESS });
        }
      })
      .catch(() => {
        if (!unmounted.current) {
          setNotification({ state: 'error', message: SUBMIT_ERROR });
        }
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setReportFormActive(false);
        }, 2000);
      });
  };

  return (
    <>
      {notification.state && (
        <Notification
          message={notification.message}
          style={notification.state}
          onClick={() => setNotification({})}
          tw='mb-4'
        />
      )}
      {(notification.state === '' || notification.state === 'error') && (
        <form onSubmit={submit} tw='overflow-auto'>
          {reportArticleOptions.map((item) => (
            <Input
              key={item.value}
              type='radio'
              label={item.label}
              value={item.value}
              checked={radioValue === item.value}
              name='reason'
              onChange={() => setRadioValue(item.value)}
            />
          ))}
          {radioValue === 'anders' && (
            <Input
              placeholder='Namelijk...'
              name='namelijk'
              id='namelijk'
              value={extraInput}
              onChange={(e) => setExtraInput(e.target.value)}
              label={extraInput ? 'Namelijk:' : ''}
            />
          )}
          <div tw='flex justify-end'>
            <Button
              type='submit'
              label={
                !loading ? (
                  'Verstuur melding'
                ) : (
                  <Icon Type={LoaderIcon} tw='animate-spin h-5' color='input-back' size='small' />
                )
              }
              primary
              disabled={loading}
            />
          </div>
        </form>
      )}
    </>
  );
};
